/**
 * @generated SignedSource<<2147d22390447d54d702c2a8ccb95dd5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveClientInput = {
  clientId: string;
};
export type Client_removeClient_Mutation$variables = {
  input: RemoveClientInput;
};
export type Client_removeClient_Mutation$data = {
  readonly removeClient: {
    readonly client: {
      readonly id: string;
    };
  } | null;
};
export type Client_removeClient_Mutation = {
  response: Client_removeClient_Mutation$data;
  variables: Client_removeClient_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RemoveClientPayload",
    "kind": "LinkedField",
    "name": "removeClient",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "client",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Client_removeClient_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Client_removeClient_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3217ae17328e5908e44601b18a6e154a",
    "id": null,
    "metadata": {},
    "name": "Client_removeClient_Mutation",
    "operationKind": "mutation",
    "text": "mutation Client_removeClient_Mutation(\n  $input: RemoveClientInput!\n) {\n  removeClient(input: $input) {\n    client {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1a40aac95b3d54ecc7c9fc23374803c";

export default node;
